import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import BaseHeaderRow from "../base-header-row/index.jsx"
import TableHeaderColumn from "@cirrus/legacy/app-components/table-v2/table-header-column/index.jsx"
import Checkbox from "@cirrus/legacy/app-components/form-controls/checkboxes/checkbox/index.jsx"

import commonStyles from "@cirrus/legacy/app-components/table-v2/common-styles/styles.less"

export default class extends C {
  static displayName = "TableHeaderRow"

  static propTypes = {
    isSelected: PropTypes.bool,
    onSelect: PropTypes.func,
    isDisabled: PropTypes.bool,
    isCheckboxColumnWidthControlled: PropTypes.bool,
  }

  static defaultProps = {
    isCheckboxColumnWidthControlled: true,
  }

  handleCheckboxChange(e, checked) {
    this.props.onSelect(checked)
  }

  render() {
    return (
      <BaseHeaderRow {...this.props}>
        <TableHeaderColumn
          htmlType={this.props.htmlType}
          className={classNames(
            commonStyles.checkboxColumn,
            {
              [commonStyles.controlledWidth]: this.props.isCheckboxColumnWidthControlled,
            },
            this.props.checkboxColumnClassName,
          )}>
          <Checkbox
            className={commonStyles.checkbox}
            checked={this.props.isSelected}
            disabled={this.props.isDisabled}
            label=""
            dataQa="table-check-all"
            onChange={this.handleCheckboxChange.bind(this)}
          />
        </TableHeaderColumn>
        {this.props.children}
      </BaseHeaderRow>
    )
  }
}
